import React from "react";
import {
  Card,
  CardBody,
  Container,
  Row,
  Col,
} from "reactstrap";

import { SeoHelper } from "../../components/helpers/SeoHelper";

class TermsOfUse extends React.Component {

  render() {
    return (
        <>
          <SeoHelper
              uri="/terms-and-conditions"
              title = "Terms of Use | The Worship Bible"
              description="These Terms of Use govern access to and use of The Worship Bible platform."
          />

          {/*<main ref="main">*/}
          <div className="position-relative">
            {/* shape Hero */}
            <section className="section section-lg section-shaped pb-250">
              <div className="shape shape-style-1 shape-default">
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
              </div>
              <Container className="py-lg-md d-flex">
                <div className="col px-0">
                  <Row>
                    <Col lg="8">
                      <h1 className="display-3 text-white">
                        Building your song-flows{" "}
                        <span>terms of use</span>
                      </h1>
                      {/*<p className="lead text-white">*/}
                      {/*  The design system comes with four pre-built pages to*/}
                      {/*  help you get started faster. You can change the text and*/}
                      {/*  images and you're good to go.*/}
                      {/*</p>*/}
                    </Col>
                  </Row>
                </div>
              </Container>
              {/* SVG separator */}
              <div className="separator separator-bottom separator-skew">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="none"
                    version="1.1"
                    viewBox="0 0 2560 100"
                    x="0"
                    y="0"
                >
                  <polygon
                      className="fill-white"
                      points="2560 0 2560 100 0 100"
                  />
                </svg>
              </div>
            </section>
            {/* 1st Hero Variation */}
          </div>


          {/* Content */}
          <section className="section section-lg pt-lg-0 mt--200">
            <Container>
              <Row className="justify-content-center">
                <Col lg="12">
                  <Card className="shadow border-0">
                    <CardBody className="py-5 terms-content">

                      <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase pt-3 pb-3">
                        Terms of Use
                      </h2>


                      <p><strong>The Worship Bible</strong></p>
                      <p><strong>Last updated: 5 June 2026</strong></p>

                      <hr/>

                      <h3 style={{fontSize: '1rem'}} className="MsoNormal text-primary">1. About Us</h3>
                      <p>
                        The Worship Bible (“we”, “us”, “our”) provides an online platform
                        designed to help worship leaders and churches plan and organise
                        worship content.
                      </p>
                      <p>
                        You can contact us at:{" "}
                        <a href="mailto:admin@theworshipbible.church">
                          admin@theworshipbible.church
                        </a>
                      </p>

                      <h3 style={{fontSize: '1rem'}} className="MsoNormal text-primary">2. Acceptance of These Terms</h3>
                      <p>
                        By accessing or using the Services, you agree to be bound by these
                        Terms of Use and our{" "}
                        <a href="/privacy-policy">Privacy Policy</a>.
                        If you do not agree, please do not use the Services.
                      </p>

                      <h3 style={{fontSize: '1rem'}} className="MsoNormal text-primary">3. Eligibility</h3>
                      <p>
                        You must be at least 18 years old and legally capable of entering
                        into a binding agreement to use the Services.
                      </p>

                      <h3 style={{fontSize: '1rem'}} className="MsoNormal text-primary">4. Accounts</h3>
                      <p>You are responsible for:</p>
                      <ul style={{marginTop: 0 + "cm", fontWeight: 300}} type="square" className="MsoNormal">
                        <li>Maintaining the confidentiality of your login credentials</li>
                        <li>All activity carried out under your account</li>
                      </ul>
                      <p>
                        We reserve the right to suspend or terminate accounts that breach
                        these Terms.
                      </p>

                      <h3 style={{fontSize: '1rem'}} className="MsoNormal text-primary">5. Intellectual Property</h3>

                      <h4 style={{fontSize: '.90rem'}} className="MsoNormal text-primary">Our content</h4>
                      <p>
                        All software, branding, design, and platform functionality are
                        owned by or licensed to us and may not be copied or reused without
                        permission.
                      </p>

                      <h4 style={{fontSize: '.90rem'}} className="MsoNormal text-primary">Your content</h4>
                      <p>
                        You retain ownership of any content you create within the Services
                        (such as playlists or song-flows).
                      </p>
                      <p>
                        By using the Services, you grant us a non-exclusive, worldwide,
                        royalty-free licence to store, display, and process your content
                        solely for the purpose of providing the Services.
                      </p>

                      <h3 style={{fontSize: '1rem'}} className="MsoNormal text-primary">6. Feedback</h3>
                      <p>
                        If you submit feedback, ideas, or suggestions, you agree that we
                        may use them freely without compensation or attribution.
                      </p>

                      <h3 style={{fontSize: '1rem'}} className="MsoNormal">7. Acceptable Use</h3>
                      <p>You agree not to:</p>
                      <ul style={{marginTop: 0 + 'cm',fontWeight: 300}} type="square" className="MsoNormal">
                        <li>Misuse or disrupt the Services</li>
                        <li>Attempt to access accounts or systems without authorisation</li>
                        <li>Upload malicious code</li>
                        <li>Use the Services for unlawful purposes</li>
                        <li>Scrape or harvest data from the platform</li>
                      </ul>

                      <h3 style={{fontSize: '1rem'}} className="MsoNormal text-primary">8. Service Availability</h3>
                      <p>
                        We aim to provide a reliable service but do not guarantee
                        uninterrupted availability. Maintenance, updates, or outages may
                        occur.
                      </p>

                      <h3 style={{fontSize: '1rem'}} className="MsoNormal text-primary">9. Termination</h3>
                      <p>
                        We may suspend or terminate access where there is a breach of these
                        Terms or misuse of the Services.
                      </p>
                      <p>You may stop using the Services at any time.</p>

                      <h3 style={{fontSize: '1rem'}} className="MsoNormal text-primary">10. Disclaimers</h3>
                      <p>
                        The Services are provided “as is”. We do not guarantee theological
                        accuracy, suitability for worship contexts, or uninterrupted
                        access.
                      </p>

                      <h3 style={{fontSize: '1rem'}} className="MsoNormal text-primary">11. Limitation of Liability</h3>
                      <p>To the fullest extent permitted by law:</p>
                      <ul style={{marginTop: 0 + 'cm', fontWeight: 300}} type="square" className="MsoNormal">
                        <li>We are not liable for indirect or consequential loss</li>
                        <li>
                          Our total liability shall not exceed the fees paid by you in the
                          12 months prior to the claim
                        </li>
                      </ul>
                      <p>
                        Nothing in these Terms limits liability for fraud or death or
                        personal injury caused by negligence.
                      </p>

                      <h3 style={{fontSize: '1rem'}} className="MsoNormal text-primary">12. Data Protection</h3>
                      <p>
                        Your use of the Services is subject to our{" "}
                        <a href="/privacy-policy">Privacy Policy</a>, which explains how
                        personal data is handled.
                      </p>

                      <h3 style={{fontSize: '1rem'}} className="MsoNormal text-primary">13. Links to Related Services</h3>
                      <p>
                        The Worship Bible may display links to{" "}
                        <a href="https://kingdomsoundtracks.com" target="_blank" rel="noopener noreferrer">
                          Kingdom Soundtracks
                        </a>
                        , a related service offering worship accompaniment tracks for purchase.
                        The Worship Bible is not responsible for any transactions, content, or
                        availability on that site. Any purchases made on Kingdom Soundtracks are
                        subject to Kingdom Soundtracks' own terms and conditions.
                      </p>

                      <h3 style={{fontSize: '1rem'}} className="MsoNormal text-primary">14. Governing Law</h3>
                      <p>
                        These Terms are governed by the laws of England and Wales, and the
                        courts of England and Wales have exclusive jurisdiction.
                      </p>

                      <h3 style={{fontSize: '1rem'}} className="MsoNormal text-primary">15. Changes to These Terms</h3>
                      <p>
                        We may update these Terms from time to time. Continued use of the
                        Services indicates acceptance of the updated Terms.
                      </p>

                      <h3 style={{fontSize: '1rem'}} className="MsoNormal text-primary">16. Contact</h3>
                      <p>
                        Questions about these Terms can be sent to{" "}
                        <a href="mailto:admin@theworshipbible.church">
                          admin@theworshipbible.church
                        </a>
                      </p>

                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </section>
        </>
    );
  }
}

export default TermsOfUse;